export enum WarehouseProductQuantityHistoryReasonType {
  NewGood = 'NEW_GOOD',
  ByReceipt = 'BY_RECEIPT',
  ByRestock = 'BY_RESTOCK',
  ByRelease = 'BY_RELEASE',
  Manual = 'MANUAL',
}
